import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9ce4528"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-down-menu none-PC" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "mobileDownMenu" }, null, -1))
const _hoisted_3 = { class: "mobile-down-menu__items" }
const _hoisted_4 = ["onClick"]

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { checkUserLoginHandler } from '@/utils/Common/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileDownMenu',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const activeMenuItemId = computed((): string | undefined => {
  if (route.name === 'main') {
    return 'home';
  }
  if (route.name === 'profile') {
    if (route.params.id === 'favorite') {
      return 'favorite';
    }
    if (route.params.id === 'chat') {
      return 'chat';
    }
    if (route.params.id === 'searchHistory') {
      return 'search';
    }

    return 'profile';
  }

  return undefined;
});
const mobileMenuItems = computed(() => {
  return [
    {
      id: 'home',
      icon: 'home',
      name: 'Главная',
      clickHandler: () => {
        router.push({ name: 'main' });
      },
    },
    {
      id: 'search',
      icon: 'search',
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile', params: { id: 'searchHistory' } });
        }),
      name: 'Поиск',
    },
    {
      id: 'favorite',
      icon: 'favorite',
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile', params: { id: 'favorite' } });
        }),
      name: 'Избранное',
    },
    {
      id: 'profile',
      icon: 'person',
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile' });
        }),
      name: 'Профиль',
    },
    {
      id: 'chat',
      icon: 'chat',
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile', params: { id: 'chat' } });
        }),
      name: 'Чаты',
    },
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileMenuItems.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id
        }, [
          _createElementVNode("button", {
            class: "items-in-column align-center gap--0",
            onClick: item.clickHandler
          }, [
            _createVNode(_component_base_icon, {
              color: activeMenuItemId.value === item.id ? '#009D3E' : '#94857d',
              name: item.icon,
              "font-size": "24"
            }, null, 8, ["color", "name"]),
            _createElementVNode("span", {
              class: _normalizeClass([activeMenuItemId.value === item.id ? 'main-color' : 'third-color', "xxs-font-size"])
            }, _toDisplayString(item.name), 3)
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}
}

})